import moment from 'moment';

export function arrival(state = { arrival: { placeholder: '', text: '' } }, action) {
  if (state.labels && state.labels.Arrival && typeof state.labels.Arrival.Loading === 'string' && typeof state.labels.Arrival.Placeholder === 'string') {
    state = {
      ...state,
      arrival: {
        ...state.arrival,
        placeholder: (state.dates === undefined || state.wizardIsFetchingDates) ? state.labels.Arrival.Loading : state.labels.Arrival.Placeholder,
      },
    };
  }

  if (state.dates) {
    if (state.wizardIsFetchingDates) {
      state = {
        ...state,
        arrival: {
          ...state.arrival,
          text: '',
        },
      };
    } else if (state.selectedArrival && state.selectedDuration) {
      const from = moment(state.selectedArrival, 'YYYYMMDD');
      const to = from.clone().add(state.selectedDuration, 'days');
      state = {
        ...state,
        arrival: {
          ...state.arrival,
          text: `${from.format('L')} – ${to.format('L')}`,
        },
      };
    }
  }

  return state;
}
